import { getStorageUtil } from '@workfront/storage'

const storageUtil = getStorageUtil({
  backend: sessionStorage,
  storagePrefix: 'wfetch:',
})

export function getCacheKeyForRequest(url, fetchOptions, workfrontOptions) {
  let cacheKey
  if (workfrontOptions.timeToExpiration) {
    try {
      cacheKey = `${url}-${simpleHash(JSON.stringify(fetchOptions))}`
    } catch (e) {
      cacheKey = url
    }
  }

  return cacheKey
}

export function getResultsFromCache(cacheKey) {
  if (cacheKey) {
    return storageUtil.get(cacheKey)
  }
}

export function cacheResponseData(cacheKey, responseData, timeToExpiration) {
  if (cacheKey && responseData) {
    storageUtil.set(cacheKey, responseData, timeToExpiration)
  }
}

const simpleHash = (str = '') =>
  str.split('').reduce((hash, character) => {
    hash = (hash << 5) - hash + character.charCodeAt(0)
    return hash & hash // Convert to 32bit integer
  }, 0)
